import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import cashback from "assets/images/icons/cashback.svg";
import totalCashback from "assets/images/icons/totalCashback.svg";
import usedCashback from "assets/images/icons/usedCashback.svg";
import Riyal from "assets/images/icons/riyal.svg";
import { CashbackIcon, TotalCashbackIcon, UsedCashBackIcon } from "components/common/SVGIcons";

const Cashback = () => {
  const { t } = useTranslation();
  const { overviewDashboard } = useSelector((state) => state.Dashboards);
  const { brandInfo } = useSelector((state) => state.auth);
  const { primaryColor } = brandInfo?.theme?.themeColors  || {};

  return (
    <Col lg={6}>
      <div className="inner_section">
        <div className="title_section">
          <CashbackIcon color={primaryColor}/>
          <h2 className="fs_20 text_black">{t("Cashback")}</h2>
        </div>
        <div className="sub_items cashback_sub_items">
          <div className="single_item">
            <TotalCashbackIcon color={primaryColor}/>
            <h2 className="fs_14 text_black mt-2">{t("Total Cashback")}</h2>
            <div className="d-flex align-items-center gap-2 mt-4">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.totalCashbackAmount?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>
          <div className="single_item">
            <UsedCashBackIcon color={primaryColor}/>
            <h2 className="fs_14 text_black mt-2">
              {t("Total Used Cashback")}
            </h2>
            <h2 className="fs_24 text_black mt-4">
              {overviewDashboard?.customers?.usedCashbacPercentage}%
            </h2>
            <div className="d-flex align-items-center gap-2 ">
              <img src={Riyal} width={17} height={19} alt="riyal" />
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.usedCashbackAmount?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>

          {(overviewDashboard?.customers?.currentUsedCashback
            ?.cashbackPercentage > 0 ||
            overviewDashboard?.customers?.currentUsedCashback?.cashbackAmount >
              0) && (
            <div className="single_item">
            <UsedCashBackIcon color={primaryColor}/>

              <h2 className="fs_14 text_black mt-2">
                {t("Current Used Cashback")}
              </h2>
              <h2 className="fs_24 text_black mt-4">
                {
                  overviewDashboard?.customers?.currentUsedCashback
                    ?.cashbackPercentage
                }
                %
              </h2>
              <div className="d-flex align-items-center gap-2 ">
                <img src={Riyal} width={17} height={19} alt="riyal" />
                <h2 className="fs_24 text_black ">
                  {overviewDashboard?.customers?.currentUsedCashback?.cashbackAmount?.toLocaleString(
                    "en-US"
                  )}
                </h2>
              </div>
            </div>
          )}
        </div>
      </div>
    </Col>
  );
};

export default Cashback;
